import ChoosePaymentMethod from '../../components/Settings/ChoosePaymentMethodModal';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';

const choosePaymentMethod = reduxForm({
  form: 'choosePaymentMethod',
})(ChoosePaymentMethod);

const selector = formValueSelector('choosePaymentMethod');

function mapStateToProps(state) {
  const IsStripe = selector(state, 'IsStripe');
  return {
    IsStripe,
  }
}

export default connect(mapStateToProps, {
  setDefaultOfForm,
})(choosePaymentMethod);


// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/ChoosePaymentMethodModal.jsx